export default __webpack_public_path__ + "assets/images/1c8c944366421d3a48c6ea01cb2a25d6.png";